"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=sticker.js.map